import React from 'react'
import {makeStyles} from '@material-ui/core/styles'
import {getClasses} from '../../helpers/mergeStylesHelper'
import Lk from '../lk/Lk'
import LkHeader from '../lk/LkHeader'
import LkHeaderAppend from '../lk/LkHeaderAppend'
import LkBody from '../lk/LkBody'
import EntityList from '../EntityList'
import {ReactComponent as BasketIcon} from '../../assets/icons/basket.svg'
import {colors} from '../../styles/colors'


const styles = {
  Root: {},
  CheckBoxText: {
    color: colors.black
  },
  BodyBottom: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginTop: 30
  },
  LeftButtonToolbar: {
    background: colors.blue
  },
  BasketButton: {
    border: 'none',
    background: 'none',
    cursor: 'pointer'
  },
  BasketIcon: {
    '& path': {
      stroke: colors.red,
      fill: colors.white
    }
  }
}
const useStyles = makeStyles(styles)

export default function LkOperatorTaksoparkaOrganizations(props) {
  const classes = getClasses(props.classes, useStyles(props), styles)

  const tableData = [
    {
      name: 'Техсервис',
      type: 'Техцентр',
      credentials: 'Проведение техосмотров',
      accreditation: 'Аккредитация',
      delete: true
    },
    {
      name: 'Техсервис',
      type: 'Техцентр',
      credentials: 'Проведение техосмотров',
      accreditation: 'Аккредитация',
      delete: true
    },
    {
      name: 'Техсервис',
      type: 'Техцентр',
      credentials: 'Проведение техосмотров',
      accreditation: 'Аккредитация',
      delete: true
    },
    {
      name: 'Техсервис',
      type: 'Техцентр',
      credentials: 'Проведение техосмотров',
      accreditation: 'Аккредитация',
      delete: true
    },
  ]

  return (
    <Lk classes={classes}>
      <LkHeader title={'оператор таксопарка'} append={
        <LkHeaderAppend
          title='Личный кабинет'
          backLink={'/some'}
        />
      } />

      <LkBody activeTab={'organizations'} type={'operator-taksoparka'}>
        <EntityList
          topToolbarSearchWidth={600}
          data={tableData}
          toolbarButtonText={'Добавить организацию'}
          toolbarLeftButtonClassName={classes.LeftButtonToolbar}
          columns={[
            {title: 'Название', field: 'name', align: 'center'},
            {title: 'Тип', field: 'type', align: 'center'},
            {title: 'Полномочия', field: 'credentials', align: 'center'},
            {title: 'Аккредитация', field: 'accreditation', align: 'center'},
            {
              title: 'Удалить запись',
              field: 'delete',
              align: 'center',
              render: () => (
                <button className={classes.BasketButton}>
                  <BasketIcon className={classes.BasketIcon} />
                </button>
              )
            },
          ]}
        />
      </LkBody>
    </Lk>
  )
}